// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const SUPPORTED_FORMATS = {
  audio: {
    ios: [
      'public.mp3',
      'public.mpeg-4-audio',
      'com.microsoft.waveform-audio',
      'public.ogg',
      'public.flac',
      'public.aac-audio',
      'public.m4a',
      'com.apple.m4a-audio',
    ],
    mimetypes: [
      'audio/mpeg',
      'audio/mp4',
      'audio/x-wav',
      'audio/ogg',
      'audio/flac',
      'audio/aac',
      'audio/m4a',
      'audio/x-m4a',
    ],
  },
  csv: {
    ios: ['public.comma-separated-values-text'],
    mimetypes: ['text/csv', 'text/comma-separated-values'],
  },
  document: {
    ios: [
      'public.plain-text',
      'com.microsoft.word.doc',
      'org.openxmlformats.wordprocessingml.document',
      'com.microsoft.excel.xls',
      'org.openxmlformats.spreadsheetml.sheet',
      'com.microsoft.powerpoint.ppt',
      'org.openxmlformats.presentationml.presentation',
      'com.adobe.pdf',
    ],
    mimetypes: [
      'text/plain',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/pdf',
    ],
  },
  image: {
    ios: ['public.jpeg', 'public.png'],
    mimetypes: ['image/jpeg', 'image/png'],
  },
  video: {
    ios: ['public.mpeg-4', 'com.apple.quicktime-movie'],
    mimetypes: ['video/mp4', 'video/quicktime'],
  },
};

export const getFileCategoriesByMimetype = (mimetype: string) => {
  const categories: string[] = [];

  Object.keys(SUPPORTED_FORMATS).forEach(category => {
    if (SUPPORTED_FORMATS[category].mimetypes.includes(mimetype)) {
      categories.push(category);
    }
  });

  return categories;
};
